const BERATUNG_FACE = "Individuelle Beratung inklusive – abgestimmt auf deine Wünsche und deinen Hautzustand.";
const BERATUNG_BODY = "Individuelle Beratung inklusive – abgestimmt auf deine Wünsche und Bedürfnisse.";

export const PRICE_GROUPS = [
  {
    id: "korean-skincare",
    index: "01",
    title: "Korean Skincare",
    subtitle: "Koreanische Gesichtsbehandlungen",
    intro: "Gesichtsbehandlungen nach dem Vorbild koreanischer Skincare-Rituale – sorgfältig, mehrstufig und ganz in Ruhe.",
    consult: BERATUNG_FACE,
    img: "/img/studio-glow.jpg",
    alt: "Gepflegte, strahlende Haut nach einer Gesichtsbehandlung im Maison Princess",
    featured: {
      title: "Individuelle Facial-Behandlung",
      desc: "Die passende Behandlung wird abhängig vom Hautzustand und den persönlichen Hautbedürfnissen ausgewählt.",
      prefix: "ab",
      price: "115 €",
    },
    items: [
      { title: "Korean Aqua Glow Facial", desc: "Feuchtigkeitsbetonte Gesichtsbehandlung nach koreanischem Vorbild – für ein frisches, gepflegtes Hautgefühl.", price: "115 €" },
      { title: "Korean Timeless Anti-Aging Ritual", desc: "Verwöhnendes Pflegeritual, abgestimmt auf die Bedürfnisse reifer Haut.", price: "149 €" },
      { title: "Korean Salmon DNA Renewal Facial", desc: "Pflegendes Renewal-Facial mit Salmon-DNA-Pflegeprodukten nach koreanischem Vorbild.", price: "149 €" },
      { title: "Korean Exosome Luxury Ritual", desc: "Exklusives Pflegeritual mit Exosomen-Pflegeprodukten – das luxuriöseste Facial im Maison Princess.", price: "175 €" },
      { title: "Korean Clear Skin Treatment", desc: "Klärende Gesichtsbehandlung für unreine Haut und Akne – sanft und individuell abgestimmt.", price: "139 €" },
      { title: "Korean Glass Skin Deluxe Package", desc: "Umfangreiches, mehrstufiges Pflegepaket nach dem koreanischen Glass-Skin-Prinzip.", price: "170 €" },
      { title: "Korean Lifting & Sculpt Facial Massage", desc: "Belebende Gesichtsmassage nach koreanischer Technik – wohltuend und entspannend für die Gesichtszüge.", duration: "30 Minuten", price: "45 €" },
    ],
  },
  {
    id: "korean-microneedling",
    index: "02",
    title: "Korean Microneedling",
    subtitle: "Behandlungsdauer ca. 60 Minuten",
    intro: "Microneedling nach koreanischem Vorbild – kombiniert mit ausgewählten Wirkstoff-Seren, abgestimmt auf deine Haut.",
    consult: BERATUNG_FACE,
    img: "/img/microneedling.jpg",
    alt: "Gesichtsbehandlung: Ein Serum wird mit einem Pinsel aufgetragen",
    pos: "50% 50%",
    items: [
      { title: "Cica Aqua Exo", desc: "Mit Cica, Peptiden und Hyaluronsäure. Für zu Unreinheiten neigende, trockene und beanspruchte Haut.", duration: "ca. 60 Minuten", price: "130 €" },
      { title: "Salmon DNA", desc: "Mit hochwertiger PDRN-Lachs-DNA. Für trockene, müde Haut mit fahlem Teint und zur Unterstützung eines gepflegten, jugendlich wirkenden Hautbildes.", duration: "ca. 60 Minuten", price: "140 €" },
      { title: "PDX Booster", desc: "Mit Exosomen, PDRN, Peptiden und Niacinamid. Für Regeneration, Anti-Aging, müde Haut mit Elastizitätsverlust, zur Unterstützung der Hautbarriere sowie bei Feuchtigkeitsmangel und Pigmentflecken.", duration: "ca. 60 Minuten", price: "160 €" },
    ],
  },
  {
    id: "basic",
    index: "03",
    title: "Basic Behandlungen",
    subtitle: "Klar, gepflegt, unkompliziert",
    intro: "Die Grundlage für ein gepflegtes Hautgefühl – ideal als Einstieg oder zwischen deinen Treatments.",
    consult: BERATUNG_FACE,
    img: "/img/basic.jpg",
    alt: "Sanfte Gesichtsbehandlung mit Pflegemaske",
    items: [
      { title: "Aquafacial Basic", desc: "Tiefenreinigung des Gesichts.", price: "100 €" },
      { title: "Dermaplaning Basic", desc: "Professionelle Gesichtshaarentfernung.", price: "59 €" },
    ],
  },
  {
    id: "specials",
    index: "04",
    title: "Special Treatments",
    subtitle: "Rituale & saisonale Auszeiten",
    intro: "Besondere Behandlungen für bewusste Momente – am Morgen oder als Auszeit für die Haut in der kalten Jahreszeit.",
    consult: BERATUNG_FACE,
    img: "/img/hero.jpg",
    alt: "Handtuch, Kerze und rosé Tulpen in heller Spa-Atmosphäre",
    items: [
      { title: "Low Cortisol Morning", desc: "Eine entspannende Morning-Behandlung für einen bewussten und ausgeglichenen Start in den Tag.", price: "99 €" },
      { title: "Peelings – Winter Reset", badge: "Saisonal", desc: "Deine Winter-Auszeit für die Haut: eine saisonale Peeling-Behandlung, die abgestorbene Hautschüppchen entfernt und für ein glatteres, frischer wirkendes Hautbild sorgt – genau das Richtige, wenn Kälte und Heizungsluft der Haut zusetzen.", price: "119 €" },
    ],
  },
  {
    id: "massage-wellness",
    index: "05",
    title: "Massage & Wellness",
    subtitle: "Wohltuende Auszeiten",
    intro: "Ruhige, entspannende Massagen für Körper und Sinne – Zeit nur für dich.",
    consult: BERATUNG_BODY,
    img: "/img/ayurveda.jpg",
    alt: "Warmes Massageöl wird für eine entspannende Rückenmassage verwendet",
    items: [
      { title: "Ayurveda-Massage (Abhyanga)", desc: "Traditionelle ayurvedische Massage mit warmem Öl – ruhig, rhythmisch und tief entspannend.", price: "Preis auf Anfrage", onRequest: true },
      { title: "Fußreflexzonen-Wellnessmassage", desc: "Eine wohltuende Massage der Füße zur Entspannung und für ein angenehmes Körpergefühl.", price: "Preis auf Anfrage", onRequest: true },
    ],
  },
  {
    id: "g8-body-contouring",
    index: "06",
    title: "G8 Body Contouring",
    subtitle: "Cellulite- & Körpermassage",
    intro: "Körperorientierte Massage zur Unterstützung eines gepflegten Hautbildes und eines angenehmen Körpergefühls.",
    consult: BERATUNG_BODY,
    img: "/img/g8-geraet.jpg",
    alt: "G8-Massagegerät bei einer Body-Contouring-Massage am Oberschenkel",
    items: [
      {
        title: "G8 Cellulite & Body Contouring Massage",
        desc: "Intensive, körperorientierte Massage mit der G8-Technik – zur Unterstützung eines gepflegten Hautbildes und eines angenehmen Körpergefühls. Das Empfinden ist individuell; bestimmte Ergebnisse können nicht garantiert werden.",
        variants: [
          { duration: "30 Minuten", price: "55 €" },
          { duration: "45 Minuten", price: "65 €" },
        ],
      },
    ],
  },
];

export const COMBO = {
  id: "kombination",
  title: "Korean Skin Renewal & G8 Body Sculpt Ritual",
  desc: "Diese Behandlung kombiniert ein koreanisches Regenerations-Facial mit einer G8 Cellulite-Massage – ein Ritual für Gesicht und Körper.",
  consult: "Individuelle Beratung inklusive – abgestimmt auf deine Wünsche, Bedürfnisse und deinen Hautzustand.",
  price: "199 €",
};

export const PACKAGES = [
  {
    id: "premium",
    title: "Premium Monthly Package",
    price: "499 €",
    tagline: "Dein exklusives Rundum-Beauty-Erlebnis.",
    includes: ["2 Skin Treatments deiner Wahl", "2 Body Treatments deiner Wahl", "Full Skin Care Starter Set für zu Hause"],
    note: "Für alle, die sich regelmäßig professionelle Pflege gönnen und ihre Beauty-Routine auch zu Hause fortsetzen möchten.",
    dark: true,
  },
  {
    id: "essential",
    title: "Essential Monthly Package",
    price: "299 €",
    tagline: "Deine persönliche Beauty-Routine für jeden Monat.",
    includes: ["1 Skin Treatment deiner Wahl", "1 Body Treatment deiner Wahl", "Full Skin Care Starter Set für zu Hause"],
    note: "Der perfekte Einstieg in eine regelmäßige Skin- und Body-Care-Routine.",
  },
];

export const BOOKING_GROUPS = [
  ...PRICE_GROUPS.map((g) => ({ label: g.title, options: [g.featured?.title, ...g.items.map((i) => i.title)].filter(Boolean) })),
  { label: "Kombinationsbehandlung", options: [COMBO.title] },
  { label: "Monthly Packages", options: PACKAGES.map((p) => p.title) },
];
